module.exports = __webpack_public_path__ + "374b719aa20daca13e3de43327e22fa7.pdf";